/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Login_Required_ToastInputs */



/**
* | output |
* | --- |
* | "You must be logged in to purchase a subscription" |
*
* @param {Signup_Login_Required_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_login_required_toast = /** @type {((inputs?: Signup_Login_Required_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Login_Required_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous devez etre connecte pour acheter un abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie müssen angemeldet sein, um ein Abonnement zu erwerben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Devi aver effettuato l'accesso per acquistare un abbonamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для приобретения подписки необходимо войти в систему.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Debes iniciar sesión para comprar una suscripción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您必须登录才能购买订阅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションを購入するにはログインする必要があります")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता खरीदने के लिए आपको लॉग इन करना होगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você precisa estar conectado para comprar uma assinatura.")
	return /** @type {LocalizedString} */ ("You must be logged in to purchase a subscription")
});